var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { ApolloConsumer } from 'react-apollo';
import { GET_BOARDS } from '.';
import { getBoardTypeName, getRoleName } from './utils';
import BoardWriter from './BoardWriter';
import Category from './Category';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 70px;\n  padding: 10px;\n  line-height: 50px;\n  overflow: hidden;\n\n  > ul {\n    width: 100%;\n    height: 50px;\n\n    > li {\n      float: left;\n      font-size: 16px;\n      text-align: center;\n      ", "\n    }\n  }\n\n  > .category {\n    width: 90%;\n    margin: 20px auto;\n  }\n"], ["\n  width: 100%;\n  min-height: 70px;\n  padding: 10px;\n  line-height: 50px;\n  overflow: hidden;\n\n  > ul {\n    width: 100%;\n    height: 50px;\n\n    > li {\n      float: left;\n      font-size: 16px;\n      text-align: center;\n      ", "\n    }\n  }\n\n  > .category {\n    width: 90%;\n    margin: 20px auto;\n  }\n"])), function (props) { return props.isTitle && "color: #aaa;"; });
var MODIFY_BOARD = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation ModifyBoard($board: ModifyingBoardPayload!) {\n    modifyBoard (board: $board)\n  }\n"], ["\n  mutation ModifyBoard($board: ModifyingBoardPayload!) {\n    modifyBoard (board: $board)\n  }\n"])));
var DELETE_BOARD = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation DeleteBoard($id: String!, $projectName: String!) {\n    deleteProjectBoard (id: $id, projectName: $projectName)\n  }\n"], ["\n  mutation DeleteBoard($id: String!, $projectName: String!) {\n    deleteProjectBoard (id: $id, projectName: $projectName)\n  }\n"])));
var Board = /** @class */ (function (_super) {
    __extends(Board, _super);
    function Board() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            modifyMode: false,
        };
        _this.modify = function (values, client) { return __awaiter(_this, void 0, void 0, function () {
            var _a, pageName, project, board;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, pageName = _a.pageName, project = _a.project, board = _a.board;
                        return [4 /*yield*/, client.mutate({
                                mutation: MODIFY_BOARD,
                                variables: {
                                    board: __assign({}, values, { id: board.id, writableRole: Number(values.writableRole) })
                                },
                                refetchQueries: [{
                                        query: GET_BOARDS,
                                        variables: {
                                            pageName: pageName,
                                            projectName: project,
                                        }
                                    }]
                            })];
                    case 1:
                        _b.sent();
                        this.setState({ modifyMode: false });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.cancel = function (e) {
            _this.setModifyMode(e, false);
        };
        _this.setModifyMode = function (e, modifyMode) {
            e.preventDefault();
            _this.setState({ modifyMode: modifyMode });
        };
        _this.delete = function (e, client) { return __awaiter(_this, void 0, void 0, function () {
            var result, _a, board, pageName, project;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        e.preventDefault();
                        result = window.confirm('정말 게시판을 삭제하시겠습니까?');
                        if (!result) return [3 /*break*/, 2];
                        _a = this.props, board = _a.board, pageName = _a.pageName, project = _a.project;
                        return [4 /*yield*/, client.mutate({
                                mutation: DELETE_BOARD,
                                variables: {
                                    id: board.id,
                                    projectName: project,
                                },
                                refetchQueries: [{
                                        query: GET_BOARDS,
                                        variables: {
                                            pageName: pageName,
                                            projectName: project,
                                        }
                                    }]
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Board.prototype.render = function () {
        var _this = this;
        var _a = this.props, board = _a.board, title = _a.title, project = _a.project, pageName = _a.pageName;
        var modifyMode = this.state.modifyMode;
        return (React.createElement(Container, { isTitle: title }, modifyMode
            ? (React.createElement(BoardWriter, { name: board.name, urlName: board.urlName, type: board.type, writableRole: board.writableRole, onSubmit: this.modify, onCancel: this.cancel }))
            : (React.createElement(React.Fragment, null,
                React.createElement("ul", null,
                    React.createElement("li", { style: { width: '20%' } }, board ? board.name : '이름'),
                    React.createElement("li", { style: { width: '15%' } }, board ? board.urlName : '영어이름'),
                    React.createElement("li", { style: { width: '15%' } }, board ? getBoardTypeName(board.type) : '유형'),
                    React.createElement("li", { style: { width: '20%' } }, board ? getRoleName(board.writableRole) : '최소 쓰기 권한'),
                    React.createElement("li", { style: { width: '10%' } }, board ? board.postCount : '글 수'),
                    title
                        ? (React.createElement(React.Fragment, null,
                            React.createElement("li", { style: { width: '10%' } }),
                            React.createElement("li", { style: { width: '10%' } })))
                        : (React.createElement(React.Fragment, null,
                            React.createElement("li", { style: { width: '10%', color: '#36c', cursor: 'pointer' }, onClick: function (e) { return _this.setModifyMode(e, true); } }, "\uC218\uC815"),
                            board.postCount === 0 && (React.createElement(ApolloConsumer, null, function (client) { return (React.createElement("li", { style: { width: '10%', color: '#f00', cursor: 'pointer' }, onClick: function (e) { return _this.delete(e, client); } }, "\uC0AD\uC81C")); }))))),
                !title && (React.createElement("div", { className: "category" },
                    React.createElement(Category, { id: board.id, categories: board.categories, projectName: project, pageName: pageName })))))));
    };
    return Board;
}(React.Component));
export default Board;
var templateObject_1, templateObject_2, templateObject_3;
